/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */

import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class ZSDTranslateService {

    constructor(private translateService: TranslateService) {
        this.translateService.addLangs(['de', 'en', 'es', 'fr', 'it', 'pl', 'nl', 'zh-CN' ,
        'zh-TW' , 'no' , 'nb' , 'nn' , 'ro' , 'sv' , 'sv-SE', 'tr', 'hu', 'pt' , 'lv', 'hi', 'ru']);

           let defaultLang = 'en';
           this.translateService.setDefaultLang(defaultLang);
           let browserLang = this.translateService.getBrowserLang();
           let browserCultureLang;
           switch (browserLang) {
               /* Chinese */
               case 'zh':
                   browserCultureLang = this.translateService.getBrowserCultureLang();
                   if (browserCultureLang.match(/-CN|CHS|Hans/i)) { // Simplified Chinese
                       this.translateService.use('zh-CN');
                   } else if (browserCultureLang.match(/-TW|CHT|Hant/i)) { // Traditional Chinese
                       this.translateService.use('zh-TW');
                   }
                   break;
               /* Swedish */
               case 'sv':
                   browserCultureLang = this.translateService.getBrowserCultureLang();
                   if (browserCultureLang.match(/-SE/i)) { // Swedish(Sweden)
                   this.translateService.use('sv-SE');
                   } else {
                   this.translateService.use('sv'); // Swedish
                   }
                   break;
               default:
                   this.translateService.use(browserLang.match(
                       /de|en|es|fr|it|pl|nl|no|nb|nn|ro|tr|hu|pt|lv|hi|ru/) ? browserLang : defaultLang );
                   break;
             }
     }

     getTranslateService() {
         return this.translateService;
     }

     getTranslatedString(component: string, key: string): string {
         /**
          * This method can be used to get the localized string from the component.
          *@param component The name of the component in which the key is present.
          *@param key The key for which string needs to be translated.
          *@returns The localized message if found or the key value if not found in the localization file.
          */
         let componentKey =  component.concat('.').concat(key);
         let componentKeyValue: string;
         this.getTranslateService().get(componentKey)
         .subscribe(
             (result: string) => {
                 componentKeyValue = result;
          });
          return componentKeyValue;
     }
   }
